import { create } from "zustand";
import { devtools } from "zustand/middleware";

type State = {
  bannerHeight: number;
};

type Action = {
  updateBannerHeight: (height: number) => void;
};

// Mirrors `useMaintenanceModeStore`'s panelHeight piece — measured height
// of the "You are viewing as..." banner, added into the same top-offset
// calculations (Layout, ShowBar) so page content never sits under it.
export const useImpersonationBannerStore = create(
  devtools<State & Action>((set) => ({
    bannerHeight: 0,
    updateBannerHeight: (bannerHeight) => {
      set({ bannerHeight });
    },
  }))
);
